module.exports = __webpack_public_path__ + "img/P1070893.b4e209db.jpg";